import { Controller } from "@hotwired/stimulus"
import { formatMoney } from "./utils/money"

// entry-preview — espelha os campos do form de lançamento num "preview vivo" que
// mostra como a linha vai aparecer no extrato (descrição, valor, natureza). Só
// apresentação: não persiste nada. CSP-safe (sem handler inline).
//
// Uso: no form, data-controller="entry-preview" com os inputs marcados por target
// (descriptionInput, amountInput, kindInput) e os alvos de exibição
// (descriptionOut, amountOut, kindOut). O sinal de kind (entrada/saída) troca a
// cor do valor via as classes de token --color-positive/--color-negative.
export default class extends Controller {
  static targets = [
    "descriptionInput", "amountInput", "kindInput",
    "descriptionOut", "amountOut", "kindOut"
  ]
  static values = {
    placeholder: String,      // texto quando a descrição está vazia
    kindLabels: Object,       // { expense: "Despesa", income: "Receita", ... }
    currency: Object          // meta da moeda (FormatHelper::CURRENCY_META)
  }

  connect() {
    this.render()
  }

  render() {
    this._renderDescription()
    this._renderKind()
    this._renderAmount()
  }

  _renderDescription() {
    if (!this.hasDescriptionOutTarget) return
    const val = this.hasDescriptionInputTarget ? this.descriptionInputTarget.value.trim() : ""
    if (val) {
      this.descriptionOutTarget.textContent = val
      this.descriptionOutTarget.classList.remove("text-muted-foreground")
    } else {
      this.descriptionOutTarget.textContent = this.placeholderValue || ""
      this.descriptionOutTarget.classList.add("text-muted-foreground")
    }
  }

  _currentKind() {
    if (!this.hasKindInputTarget) return "expense"
    // kind pode vir de um radio group (segmented) ou de um select.
    const checked = this.kindInputTargets.find((el) => el.checked)
    if (checked) return checked.value
    const el = this.kindInputTarget
    return el.value || "expense"
  }

  _renderKind() {
    const kind = this._currentKind()
    if (this.hasKindOutTarget) {
      const labels = this.kindLabelsValue || {}
      this.kindOutTarget.textContent = labels[kind] || ""
    }
  }

  _renderAmount() {
    if (!this.hasAmountOutTarget) return
    const kind = this._currentKind()
    const isIncome = kind === "income" || kind === "refund"
    const cents = this._parseCents()

    const formatted = this._formatMoney(cents)
    const sign = cents === 0 ? "" : (isIncome ? "+" : "−")
    this.amountOutTarget.textContent = `${sign}${formatted}`

    this.amountOutTarget.classList.toggle("text-positive", cents !== 0 && isIncome)
    this.amountOutTarget.classList.toggle("text-negative", cents !== 0 && !isIncome)
    this.amountOutTarget.classList.toggle("text-muted-foreground", cents === 0)
  }

  // Lê o input mascarado (R$ 1.234,56) e devolve os centavos inteiros.
  _parseCents() {
    if (!this.hasAmountInputTarget) return 0
    const raw = this.amountInputTarget.value.replace(/[^\d]/g, "")
    return raw ? parseInt(raw, 10) : 0
  }

  // Formata pelo meta da moeda do app (mesmo algoritmo do servidor). Antes fixava
  // "R$" e pt-BR aqui, divergindo do render quando a moeda não era BRL.
  _formatMoney(cents) {
    return formatMoney(cents, this.currencyValue)
  }
}
